import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

const TEXT_ERROR_REFRESH = 'Сессия истекла';

const ApiClient = axios.create();
export default ApiClient;
